
import React from 'react'
import {BackgroundCircles} from '../components'
import {Cursor, useTypewriter} from 'react-simple-typewriter'
import logo from '../assets/me/logo.jpg'

function Hero() {
    const [text, count] = useTypewriter({
        words:[
            "Hi am Nqaba Sikeyi",
            "Guy-who-loves-Anime.tsx",
            "<ButLovesCodeEvenMore/>",
        ],
        loop: true,
        delaySpeed:2000,
    });

  return (
    <div className='h-screen flex flex-col space-y-8 items-center justify-center text-center overflow-hidden'>
        <BackgroundCircles/>
        <img className='relative rounded-full mx-auto object-cover' src={logo} alt="nqaba" height={150} width={150}/>
        <div>
            <h2 className='text-sm uppercase text-gray-500 pb-2 tracking-[15px]'>Software Engineer</h2>
        
        
        <h1 className='text-3xl lg:text-6xl font-semibold px-10 sm:text-3xl'>
           <span>{text}</span>
           <Cursor cursorColor='#F7ABOA'/>
        </h1>
  
  </div>
  <div className="pt z-20">
    <a href="#about">
       <button className="heroButton">About</button>
    </a>
    <a href="https://drive.google.com/file/d/1Hzla9VYrV2Y4WPvlHDyTlbk-0QT0nxB_/view?usp=drive_link"
		target='_blank'
		>
       <button className="heroButton">View CV</button>
    </a>
    <a href="#experience">
       <button className="heroButton">Experience</button>
    </a>
    <a href="#skills">
       <button className="heroButton">Skills</button>
    </a>
    <a href="#projects">
       <button className="heroButton">Projects</button>
    </a>
    
  </div>
    </div>
  )
}

export default Hero